import { useCallback, useState } from "react";
import { putSectionStyleURL } from "../../utils/ConstantsURL";
import { unwrapApiResponse } from "../../utils/apiResponse";
import { STYLE_ATTRIBUTE_EN_MAP } from "../../editor/selectaAdmin/configurationSyles/globalStylesSection/constants/styleDefaults";

export const usePutSectionStyle = (token, setStylesBySectionId) => {
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);

  const saveSectionStyle = useCallback(
    async (sectionId, record) => {
      if (!sectionId) return { success: false, error: "ID de sección requerido" };
      setSaving(true);
      setSaveError(null);
      try {
        const payloadToSave = {};
        for (const [key, value] of Object.entries(record)) {
          const engKey = STYLE_ATTRIBUTE_EN_MAP[key] || key;
          payloadToSave[engKey] = value;
        }

        const res = await fetch(putSectionStyleURL(sectionId), {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payloadToSave),
        });
        
        const data = await unwrapApiResponse(res);

        setStylesBySectionId((prev) => ({
          ...prev,
          [sectionId]: data?.stylesEs || {},
        }));

        return { success: true, data };
      } catch (e) {
        console.error("usePutSectionStyle:", e);
        const msg = e.message || "Error al actualizar estilos";
        setSaveError(msg);
        return { success: false, error: msg };
      } finally {
        setSaving(false);
      }
    },
    [token, setStylesBySectionId]
  );

  return {
    saving,
    saveError,
    saveSectionStyle,
  };
};

export default usePutSectionStyle;
